import { AppProviders } from "web/Providers"
import { BrowserRouter as Router } from "react-router-dom"
import { Controller } from "@hotwired/stimulus"
import { Loading } from "web/components"
import { render, unmountComponentAtNode } from "react-dom"
import { DealOrganizationOverview } from "web/components/ObjectOverview"
import React, { Suspense } from "react"

export default class DealOrganizationOverviewController extends Controller {
  static values = {
    overviewId: Number,
    dealId: Number,
  }

  initialize() {
    global.React = React
  }

  connect() {
    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <AppProviders>
            <DealOrganizationOverview
              dealId={this.dealIdValue}
              overviewId={this.overviewIdValue}
            />
          </AppProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }

  disconnect() {
    unmountComponentAtNode(this.element)
  }
}
